export default __webpack_public_path__ + "static/Design System-cbfb07ee9c6812ba7f635faefe6246c2.png";